<pv-view #view *ngIf="state$ | async as state" toolbarTitle="Transfer Evaluations">

    <!-- SIDEBAR START -->
    <div pv-view-sidebar>
        <mat-tab-group animationDuration="0">

            <mat-tab label="Evaluations">
                <ng-template matTabContent>
                    <div class="pv-form single-column dense p-12 eval-transfer-form">
                        <div class="sample-detail-wrapper" *ngIf="state.sample as sample">
                            <pv-image-ref *ngIf="sample.primaryImage as image; else sampleIcon"
                                        transformId="thumb_300"
                                        [fileRef]="image.fileRef">
                            </pv-image-ref>
                            <ng-template #sampleIcon>
                                <mat-icon [svgIcon]="'common:' + sample.scionCultivar.cropId"></mat-icon>
                            </ng-template>

                            <div class="sample-detail">
                                <h4 class="m-0">{{ sample.label }}</h4>
                                <div>{{ sample.code }}</div>
                                <ng-container *ngIf="sample.type === 'plant'; else harvestInfo">
                                    <h5 class="m-0">
                                        Planted
                                        {{ sample.birthDate | amDateFormat:'ll' }}
                                    </h5>
                                </ng-container>
                                <ng-template #harvestInfo>
                                    <h6 class="m-0">
                                        Harvested
                                        {{ sample.birthDate | amDateFormat:'[week] W' }},
                                        {{ sample.birthDate | amDateFormat:'ll' }}
                                    </h6>
                                </ng-template>
                            </div>
                        </div>

                        <div class="evaluation-wrapper pb-sm">
                            <ng-container *ngFor="let evalu of state.sample?.evals">
                                <mat-checkbox
                                    (click)="$event.stopPropagation()"
                                    (change)="$event ? selection.toggle(evalu.key) : null"
                                    [checked]="selection.isSelected(evalu.key)">
                                        <div class="evaluation-detail">
                                            <span class="eval-label">{{ evalu.label }}</span>
                                            <span>{{ evalu.evalStartDate | amDateFormat:'ll' }}</span>
                                        </div>
                                </mat-checkbox>
                            </ng-container>
                        </div>

                        <div class="form-actions">
                            <button mat-flat-button
                                color="primary"
                                type="submit"
                                name="import"
                                (click)="attempt()">
                                    Submit
                            </button>
                    </div>
                    </div>
                </ng-template>
            </mat-tab>

            <mat-tab label="Filter">
                <ng-template matTabContent>
                    <form class="pv-form single-column dense p-12 eval-transfer-form" [formGroup]="queryFormGroup">
                        <div class="search-group pb-sm">
                            <mat-form-field appearance="outline">
                                <mat-label>
                                    <mat-icon>search</mat-icon> Search Samples
                                </mat-label>
                                <input type="text" matInput formControlName="search"
                                    placeholder="Enter sample code or label">
                            </mat-form-field>

                            <button mat-icon-button type="button" color="warn" matTooltip="Clear Filters"
                                    (click)="resetFilter()">
                                <mat-icon>filter_alt_off</mat-icon>
                            </button>
                        </div>

                        <mat-form-field appearance="fill">
                            <mat-label>
                                <mat-icon svgIcon="common:flat_scion"></mat-icon>
                                <span>Filter Scion Cultivar(s)</span>
                            </mat-label>
                            <pv-cultivar-autocomplete-chips formControlName="scionCultivars"
                                                            [orgKey]="state.orgKey"
                                                            cropId="apple">
                            </pv-cultivar-autocomplete-chips>
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                            <mat-label>
                                <mat-icon svgIcon="common:flat_rootstock"></mat-icon>
                                <span>Filter Rootstock Cultivar(s)</span>
                            </mat-label>
                            <pv-cultivar-autocomplete-chips formControlName="rootstockCultivars"
                                                            [orgKey]="state.orgKey">
                            </pv-cultivar-autocomplete-chips>
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                            <mat-label>
                                <mat-icon>place</mat-icon>
                                <span>Filter Location(s)</span>
                            </mat-label>
                            <pv-site-autocomplete-chips formControlName="sites"
                                                        [orgKey]="state.orgKey">
                            </pv-site-autocomplete-chips>
                        </mat-form-field>

                        <mat-form-field appearance="fill" *ngIf="groups$ | async as groups; else groupLoader">
                            <mat-label>Filter Group</mat-label>
                            <mat-select formControlName="groupKey" multiple>
                                <mat-option *ngFor="let group of groups" [value]="group.key">
                                    <mat-icon svgIcon="common:{{ group.type }}_sample"></mat-icon>&nbsp;{{ group.label }}
                                </mat-option>
                            </mat-select>
                            <mat-error>Select a group</mat-error>
                        </mat-form-field>
                        <ng-template #groupLoader>
                            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                        </ng-template>

                        <mat-form-field appearance="fill">
                            <mat-label>Filter Licensee</mat-label>
                            <mat-select formControlName="scionLicensee" multiple>
                                <mat-option *ngFor="let licensee of state.licenseeOptions"
                                            [value]="licensee">{{ licensee }}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <div class="flex-row">
                            <mat-form-field appearance="fill" class="col-50" floatLabel="always">
                                <mat-label>Harvest/Plant Year</mat-label>
                                <mat-select formControlName="birthYear" multiple>
                                    <mat-option *ngFor="let year of yearOptions" [value]="year">
                                        {{ year }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field appearance="fill" class="col-50" floatLabel="always">
                                <mat-label>Week</mat-label>
                                <mat-select formControlName="birthWeek" multiple>
                                    <mat-option *ngFor="let week of weekOptions" [value]="week">
                                        {{ week }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="pb-sm">
                            <mat-checkbox formControlName="excludeYear">Exclude Years</mat-checkbox>
                            <span class="mat-checkbox-hint">Exclude samples with selected Harvest/Plant year</span>
                        </div>

                        <div class="flex-row">
                            <mat-form-field appearance="fill" class="col-50" floatLabel="always">
                                <mat-label>Row</mat-label>
                                <span matPrefix>R</span>
                                <input matInput type="text" formControlName="rowIndex">
                                <mat-error>Invalid range/set</mat-error>
                            </mat-form-field>
                            <mat-form-field appearance="fill" class="col-50" floatLabel="always">
                                <mat-label>Position</mat-label>
                                <span matPrefix>.</span>
                                <input matInput type="text" formControlName="positionIndex">
                                <mat-error>Invalid range/set</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="flex-row">
                            <mat-form-field floatLabel="always" appearance="fill" class="col-100">
                                <mat-label>Hide Destroyed Samples</mat-label>
                                <mat-slide-toggle formControlName="hideDestroyed"></mat-slide-toggle>
                                <textarea matInput hidden></textarea>
                            </mat-form-field>
                        </div>

                        <div class="flex-row">
                            <mat-form-field appearance="fill" class="col-100">
                                <input formControlName="startEvalPeriod" matInput [matDatepicker]="startEvalPeriodPicker" placeholder="Choose a start date">
                                <mat-label>Evaluation Period Start</mat-label>
                                <mat-hint>Filter Samples with Evaluations from this date</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="startEvalPeriodPicker"></mat-datepicker-toggle>
                                <mat-datepicker #startEvalPeriodPicker></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="flex-row">
                            <mat-form-field appearance="fill" class="col-100">
                                <input formControlName="endEvalPeriod" matInput [matDatepicker]="endEvalPeriodPicker" placeholder="Choose an end date">
                                <mat-label>Evaluation Period End</mat-label>
                                <mat-hint>Filter Samples with Evaluations before this date</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="endEvalPeriodPicker"></mat-datepicker-toggle>
                                <mat-datepicker #endEvalPeriodPicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </form>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>
    <!-- SIDEBAR END -->

    <!-- BODY START -->
    <div pv-view-body class="grid-wrapper" [ngSwitch]="state.status">

        <!--* STATUS: LOADING -->
        <pv-view-loader *ngSwitchCase="'LOADING'" message="Loading data..."></pv-view-loader>

        <!--* STATUS: EMPTY -->
        <pv-view-message *ngSwitchCase="'EMPTY'"
                         heading="No results"
                         message="The current filters does not match any Samples."
                         icon="error">
            <button mat-raised-button color="accent"
                    pvMessageAction
                    (click)="resetFilter()">
                Reset Filters
            </button>
        </pv-view-message>

        <!--* STATUS: OK -->
        <ng-container *ngSwitchCase="'OK'">
            <div class="sample-grid">
                <ng-container *ngFor="let sample of state.data">
                    <pv-sample-card
                        [sample]="sample"
                        [isActive]="selectedSampleKey == sample.key"
                        (click)="selectSample(sample.key)">
                    </pv-sample-card>
                </ng-container>
            </div>
        </ng-container>

        <!--* STATUS: ERROR / DEFAULT -->
        <pv-view-message *ngSwitchDefault [heading]="state.status | descStatusTitle"
                         [message]="state.status | descStatusMessage:'Sample'" icon="error">
            <button mat-raised-button color="primary" pvMessageAction
                    (click)="reload()">Reload</button>
        </pv-view-message>
    </div>
    <!-- BODY END -->

    <!-- PAGINATION & SORT FOOTER -->
    <div pv-view-footer class="pv-table-footer">

        <label class="mat-caption mr-12" for="eval_transfer_sort">Sort</label>
        <mat-select [formControl]="columnControl"
                    id="eval_transfer"
                    class="eval-transfer-sort-select">
            <mat-option *ngFor="let opt of state.sortOptions" [value]="opt.id">{{ opt.label }}
            </mat-option>
        </mat-select>
        <button type="button" class="ml-12" mat-icon-button (click)="toggleSortOrder($event)" matTooltip="Change Sort Direction">
            <mat-icon
                      [svgIcon]="orderControl.value === 'asc' ? 'fa:solid-sort-alpha-up' : 'fa:solid-sort-alpha-down'">
            </mat-icon>
        </button>

        <mat-paginator [length]="state.total"
                       [pageSize]="state.page.size"
                       [pageIndex]="state.page.index"
                       (page)="paginate($event)"
                       [pageSizeOptions]="state.pageSizeOptions">
        </mat-paginator>
    </div>
    <!-- PAGINATION & SORT FOOTER END-->

    <!-- FAB -->
    <ng-container pv-view-fab *ngIf="state.sample as sample">
        <button pv-view-fab mat-fab color="primary" (click)="back(sample)" matTooltip="Return to sample detail">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </ng-container>
</pv-view>